import cx from 'classix'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Section from '@components/common/layout/Section'
import ArrowedButtonLink from '@components/revamp/ArrowedButtonLink'

import officeCoverImage from '@src/assets/images/office/office-cover-60.jpg'
import i18n from '@src/config/i18n'
import locales from '@src/config/locales'
import { TitleLink } from '@src/types/common'

export default function OurOfficesSection() {
  const { t } = useTranslation('revamp')
  const breakpoints = useBreakpoint()
  const locale = i18n.language

  const [activeTab, setActiveTab] = useState<'montreal' | 'quebec'>('quebec')

  const videos = {
    quebec: t('officePage.videos.quebec', {
      returnObjects: true,
    }) as TitleLink,
    montreal: t('officePage.videos.montreal', {
      returnObjects: true,
    }) as TitleLink,
  }

  const selectedVideo = videos[activeTab]

  return (
    <div
      className='bg-bottom bg-no-repeat'
      style={{
        backgroundImage: `url(${officeCoverImage})`,
        backgroundColor: '#F8EBE580',
        backgroundBlendMode: 'color-burn',
        backgroundSize: breakpoints.lg3 ? '100% 60%' : breakpoints.md ? '100% 40%' : 'initial',
      }}
    >
      <Section className='text-revamp-neutral-700 py-20 flex flex-col items-center'>
        <h3 className='text-center font-bold text-r-5xl leading-none'>{t('visitOurOffices')}</h3>
        <p className='text-r-2xl leading-small text-center mt-6'>{t('visitOurOfficesText')}</p>
        <div className='flex gap-7 mt-12 mb-8'>
          {['quebec', 'montreal'].map((city) => (
            <button
              key={`office_button_${city}`}
              type='button'
              className={cx('leading-small text-r-lg text-revamp-neutral-700 font-semibold')}
              onClick={() => setActiveTab(city as 'quebec' | 'montreal')}
              style={{
                borderBottomWidth: 3,
                borderColor: activeTab === city ? '#282828' : 'transparent',
              }}
            >
              {t(city)}
            </button>
          ))}
        </div>
        <article className='w-full mb-8'>
          <iframe
            className='rounded-lg w-full h-auto mx-auto'
            src={selectedVideo.link}
            title={selectedVideo.title}
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
            style={{ aspectRatio: '16/9', maxWidth: '1000px', minHeight: '300px' }}
          ></iframe>
        </article>
        <ArrowedButtonLink
          className='text'
          text={t('discoverOurOffices')}
          to={locales[locale].ourOfficesPath}
          variant='outline-primary'
        />
      </Section>
    </div>
  )
}
